import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-checker" }
const _hoisted_2 = { class: "default-checker__checkbox default-checker__checkbox--ma_none" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "qin-checkbox-main__label" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/static/app/check-icon.svg" })
], -1)
const _hoisted_5 = { class: "default-checker__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["qin-checkbox-main", $setup.props.value ? 'qin-checkbox-main--active' : 'qin-checkbox-main'])
      }, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            class: "checker",
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.value) = $event)),
            value: $setup.props.value,
            onChange: _cache[1] || (_cache[1] = ($event: any) => {$setup.emit('check', $setup.value);})
          }, null, 40, _hoisted_3), [
            [_vModelCheckbox, $setup.value]
          ]),
          _hoisted_4
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, _toDisplayString($setup.props.title), 1)
    ])
  ]))
}